var footerHeading = document.querySelectorAll(".footer-heading");
footerHeading.forEach((heading) => {
  heading.addEventListener("click", () => {
    var footerMenu = heading.closest(".footer-menu");
    var footerBody = footerMenu?.querySelector(".footer-body");
    var footerImage = heading.querySelector("img");

    if (footerBody) {
      if (footerBody.classList.contains("hidden")) {
        footerBody.classList.remove("hidden");
        footerBody.classList.add("grid");
        footerImage.classList.add("rotate-180");
      } else {
        footerBody.classList.add("hidden");
        footerBody.classList.remove("grid");
        footerImage.classList.remove("rotate-180");
      }
    }
  });
});

var customerHeading = document.querySelector(".customer-service-heading");
customerHeading?.addEventListener("click", () => {
  var customerMenu = customerHeading.closest(".customer-service-menu");
  var customerImage = customerHeading.querySelector("a img");
  var customerAnchor = customerHeading.querySelector("a");
  var customerItem = customerMenu?.querySelectorAll(".customer-service-item");

  if (!customerImage.classList.contains("rotate-[270deg]")) {
    customerImage.classList.remove("rotate-90");
    customerImage.classList.add("rotate-[270deg]");
    customerAnchor.classList.add("border-b", "pb-4");
  } else {
    customerImage.classList.remove("rotate-[270deg]");
    customerImage.classList.add("rotate-90");
    customerAnchor.classList.remove("border-b", "pb-4");
  }

  if (customerItem) {
    customerItem.forEach((item) => {
      if (item) {
        if (item.classList.contains("hidden")) {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      }
    });
  }
});

const faqs = document.querySelectorAll(".faq-item-heading");
faqs.forEach((faq) => {
  faq.addEventListener("click", function () {
    const faqBody = faq.nextElementSibling;
    const faqChevron = faq.querySelector(".faq-item-chevron");

    if (faqBody && faqBody.classList.contains("faq-item-body")) {
      if (faqBody.classList.contains("hidden")) {
        faqBody.classList.remove("hidden");
        faqChevron.classList.add("rotate-180");
      } else {
        faqBody.classList.add("hidden");
        faqChevron.classList.remove("rotate-180");
      }
    }
  });
});

var customerSlider = new Swiper(".customer-service-slider", {
  slidesPerView: 1,
  grabCursor: true,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var blogSlider = new Swiper(".blogs-slider", {
  slidesPerView: 1.4,
  spaceBetween: 24,
  grabCursor: true,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 2.4,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

var productSlider = new Swiper(".products-slider", {
  slidesPerView: 1.4,
  spaceBetween: 24,
  grabCursor: true,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 2.4,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

var collectionSlider = new Swiper(".collection-slider", {
  slidesPerView: 1.4,
  spaceBetween: 24,
  grabCursor: true,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 2.4,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

var popularSlider = new Swiper(".popular-slider", {
  slidesPerView: 1.4,
  spaceBetween: 24,
  grabCursor: true,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 2.4,
    },
    768: {
      slidesPerView: 3,
    },
  },
});

var categorySlider = new Swiper(".category-slider", {
  slidesPerView: 1.4,
  spaceBetween: 24,
  grabCursor: true,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 2.4,
    },
    768: {
      slidesPerView: 3,
    },
  },
});

var uspSlider = new Swiper(".usp-slider", {
  slidesPerView: 1,
  spaceBetween: 24,
  grabCursor: true,
  loop: true,
  autoplay: true,
});

var galleryThumbSlider = new Swiper(".gallery-thumbs-swiper", {
  spaceBetween: 8,
  slidesPerView: 3,
  slidesPerGroup: 2,
  navigation: {
    nextEl: ".right-arrow",
    prevEl: ".left-arrow",
  },
  freeMode: true,
  breakpoints: {
    768: {      
      slidesPerView: 5,
    }
  }
});

var gallerySlider = new Swiper(".gallery-swiper", {
  spaceBetween: 10,
  loop: true,
  autoHeight: true,
  thumbs: {
    swiper: galleryThumbSlider,
  },
});


/** Desktop menu functions */
const menuItems = document.querySelectorAll("[data-menu]");
const menuParents = document.querySelectorAll("[data-menu-parent]");
const menuBrands = document.querySelector(".menu-brands");
const brands = document.querySelectorAll("[data-brands]");

menuItems.forEach((item) => {
  item.addEventListener("mouseenter", function () {
    const target = this.getAttribute("data-menu");

    menuItems.forEach((child) => {
      child.classList.remove("active");
    });

    item.classList.add("active");

    // Hide all submenus first
    menuParents.forEach((parent) => {
      parent.style.display = "none";
      parent.classList.remove("active-menu");
    });

    // Show ALL matching submenus (in case multiple exist)
    const matches = document.querySelectorAll(`[data-menu-parent="${target}"]`);
    const currentBrand = document.querySelector(`[data-brands="${target}"]`);

    menuBrands.style.display = "none";
    brands.forEach((parent) => {
      parent.classList.remove("flex");
      parent.classList.add("hidden");
    });

    if (currentBrand) {
      currentBrand.classList.remove("hidden");
      currentBrand.classList.add("flex");
      menuBrands.style.display = "block";
    }

    if (menuBrands) {
      if (matches.length > 0) {
        // Show brands if there’s a submenu match
        menuBrands.classList.remove("hidden");
      } else {
        // Hide brands if no match
        menuBrands.classList.add("hidden");
      }
    }

    matches.forEach((match) => {
      match.style.display = "flex"; // flex to keep your Tailwind layout
    });
  });
});

/** Pop-up functions */
const popupWrapper = document.querySelector(".pop-up--wrapper");
const popupOpen = document.querySelector(".pop-up--open");
const popupClose = document.querySelector(".pop-up--close");
const popupAction = document.querySelector(".pop-up--action");
const popupInformation = document.querySelector(".pop-up--information");

setTimeout(() => {
  popupWrapper?.classList.remove("opacity-0", "invisible");
  popupWrapper?.classList.add("opacity-100", "visible");
}, 2000);

popupOpen?.addEventListener("click", (e) => {
  if (!popupAction.classList.contains("pop-up--close-effect")) {
    popupAction.classList.add("pop-up--close-effect");
  }
  if (!popupInformation.classList.contains("pop-up--active")) {
    popupInformation.classList.add("pop-up--active");
  }
});

popupClose?.addEventListener("click", (e) => {
  if (popupAction.classList.contains("pop-up--close-effect")) {
    popupAction.classList.remove("pop-up--close-effect");
  }
  if (popupInformation.classList.contains("pop-up--active")) {
    popupInformation.classList.remove("pop-up--active");
  }
});

/** Mobile menu functions */
const mobileMenuToggler = document.querySelector(".mobile-menu-toggler");
const mobileMenu = document.querySelector(".mobile-menu");
const mobileMenuClose = document.querySelector(".mobile-menu--close");

mobileMenuToggler?.addEventListener("click", () => {
  mobileMenu.classList.add("mobile-menu--active");
});

mobileMenuClose?.addEventListener("click", () => {
  mobileMenu.classList.remove("mobile-menu--active");
});

/** Product card sell **/
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".product_card_sell_btn");
  if (!btn) return;

  const card = btn.closest(".product_card_sell");
  if (!card) {
    console.error("No .product_card_sell ancestor found");
    return;
  }

  const qtySelect = card.querySelector("select[name='product_card_sell_qty']");
  if (!qtySelect) {
    console.error("No select[name='product_card_sell_qty'] found in the card");
    return;
  }

  // Parse qty and variant id safely
  const qty = parseInt(qtySelect.value, 10);
  let variantId =
    qtySelect.dataset.variantId ||
    qtySelect.getAttribute("data-variant-id") ||
    card.dataset.variantId ||
    btn.dataset.variantId ||
    null;

  if (!variantId) {
    console.error(
      "Variant id not found on select, card, or button (data-variant-id missing)."
    );
    return;
  }

  variantId = parseInt(variantId, 10);
  if (isNaN(variantId)) {
    console.error("Variant id is not a number:", variantId);
    return;
  }
  if (isNaN(qty) || qty < 1) {
    console.error("Invalid quantity:", qty);
    return;
  }

  const payload = { id: variantId, quantity: qty };
  // Pre-order (snippets/preorder.liquid): verwachte week als regel-eigenschap mee naar winkelwagen en bestelling
  if (qtySelect.dataset.preorderValue) {
    payload.properties = { [qtySelect.dataset.preorderName]: qtySelect.dataset.preorderValue };
  }

  // First: add the product
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then(async (response) => {
      const text = await response.text();
      let json;
      try {
        json = text ? JSON.parse(text) : {};
      } catch (err) {
        console.error("Response is not valid JSON:", text);
      }

      if (!response.ok) {
        console.error("Add to cart failed:", {
          status: response.status,
          statusText: response.statusText,
          body: json || text,
        });
        throw new Error(
          "Add to cart failed: " +
            (json && json.description ? json.description : response.status)
        );
      }

      return json; // this is the single added item
    })
    .then(() => {
      // Second: fetch the full cart
      return fetch("/cart.js", {
        headers: {
          Accept: "application/json",
        },
      }).then((res) => res.json());
    })
    .then((cart) => {
      console.log("Updated cart:", cart);
      document.dispatchEvent(new CustomEvent("godu:cart:add")); // opent de cart-drawer
      updateSmallcart();
    })
    .catch((err) => {
      console.error("Fetch error:", err);
    });
});

/** Product add bundle */
var bundleBtn = document.querySelector(".add-bundle");
bundleBtn?.addEventListener("click", (e) => {
  var productId = bundleBtn.dataset.variantId;

  // Build items array
  var items = [{ id: productId, quantity: 1 }];

  var checkedBoxes = document.querySelectorAll(".add-bundle-product:checked");
  checkedBoxes.forEach((checkbox) => {
    items.push({
      id: checkbox.dataset.variantId,
      quantity: 1,
    });
  });

  if (items.length) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }), // note the { items: [...] }
    })
      .then(async (response) => {
        const text = await response.text();
        let json;
        try {
          json = text ? JSON.parse(text) : {};
        } catch (err) {
          console.error("Response is not valid JSON:", text);
        }

        if (!response.ok) {
          console.error("Add to cart failed:", {
            status: response.status,
            statusText: response.statusText,
            body: json || text,
          });
          throw new Error(
            "Add to cart failed: " +
              (json && json.description ? json.description : response.status)
          );
        }

        return json;
      })
      .then(() =>
        fetch("/cart.js", { headers: { Accept: "application/json" } })
      )
      .then((res) => res.json())
      .then((cart) => {
        console.log("Updated cart:", cart);
        document.dispatchEvent(new CustomEvent("godu:cart:add")); // opent de cart-drawer
        updateSmallcart();
      })
      .catch((err) => console.error("Fetch error:", err));
  }
});

/** Product add sample **/
var sampleBtn = document.querySelector(".atc-sample");
sampleBtn?.addEventListener("click", (e) => {
  var productId = sampleBtn.dataset.variantId;
  var productTitle = sampleBtn.dataset.title;

  var payload = {
    id: productId,
    quantity: 1,
    properties: {
      Sample: productTitle,
    },
  };

  if (payload) {
    // First: add the product
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const text = await response.text();
        let json;
        try {
          json = text ? JSON.parse(text) : {};
        } catch (err) {
          console.error("Response is not valid JSON:", text);
        }

        if (!response.ok) {
          console.error("Add to cart failed:", {
            status: response.status,
            statusText: response.statusText,
            body: json || text,
          });
          throw new Error(
            "Add to cart failed: " +
              (json && json.description ? json.description : response.status)
          );
        }

        return json; // this is the single added item
      })
      .then(() => {
        // Second: fetch the full cart
        return fetch("/cart.js", {
          headers: {
            Accept: "application/json",
          },
        }).then((res) => res.json());
      })
      .then((cart) => {
        console.log("Updated cart:", cart);
        document.dispatchEvent(new CustomEvent("godu:cart:add")); // opent de cart-drawer
        updateSmallcart();
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  }
});

function showCustomCartNotification(shoppingcart, show = true) {
  const miniCarts = document.querySelectorAll(".mini-cart");

  miniCarts.forEach((miniCart) => {
    const miniCartItems = miniCart.querySelector(".mini-cart-items");

    // Make sure mini cart is visible
    miniCart.classList.remove("hidden");

    // Clear old content
    miniCartItems.innerHTML = "";

    if ("items" in shoppingcart && shoppingcart.items.length > 0) {
      shoppingcart.items.forEach((item) => {
        const itemDiv = document.createElement("div");
        itemDiv.className = "flex justify-between items-center gap-4 py-4";

        const leftDiv = document.createElement("div");
        leftDiv.className = "flex items-center gap-4";

        const img = document.createElement("img");
        img.src = item.image;
        img.alt = item.title;
        img.className = "w-10 h-10 object-cover rounded-[4px]";

        const titleP = document.createElement("p");
        titleP.className = "text-xs";
        titleP.textContent = item.title;

        leftDiv.appendChild(img);
        leftDiv.appendChild(titleP);

        const priceSpan = document.createElement("span");
        priceSpan.className = "text-sm font-bold";
        priceSpan.textContent = Shopify.formatMoney(item.line_price).replace(
          /[^0-9,.]/g,
          ""
        );
        // stripping currency if you want `money_without_currency`

        itemDiv.appendChild(leftDiv);
        itemDiv.appendChild(priceSpan);

        miniCartItems.appendChild(itemDiv);
      });

      // Add total + link
      const totalDiv = document.createElement("div");
      totalDiv.className =
        "flex justify-between items-center font-bold mt-2 pt-4 border-t border-b-[#d8dbe0]";
      totalDiv.innerHTML = `Totaal: <span>${Shopify.formatMoney(
        shoppingcart.total_price
      ).replace(/[^0-9,.]/g, "")}</span>`;

      // Add button
      const cartLink = document.createElement("a");
      cartLink.href = "/cart";
      cartLink.className = "btn btn-light-green w-full mt-4";
      cartLink.textContent = "Naar winkelwagen";

      miniCartItems.appendChild(totalDiv);
      miniCartItems.appendChild(cartLink);
    } else {
      // Empty cart message
      const emptyP = document.createElement("p");
      emptyP.textContent = "Je winkelwagen is leeg.";
      miniCartItems.appendChild(emptyP);
    }
  });
}

function hideCustomCartNotification() {
  const miniCarts = document.querySelectorAll(".mini-cart");
  miniCarts.forEach((miniCart) => {
    miniCart.classList.add("hidden");
    const miniCartItems = miniCart.querySelector(".mini-cart-items");
    if (miniCartItems) miniCartItems.innerHTML = "";
  });
}

async function updateSmallcart() {
  const cart_counts = document.querySelectorAll(".cart-count p");

  try {
    // Fetch the latest cart data
    const cart = await fetchCartItems();

    if (cart) {
      const item_count = cart.item_count;
      cart_counts.forEach((el) => {
        el.textContent = item_count;
      });
    }
  } catch (error) {
    console.error("Error updating small cart:", error);
  }
}

async function fetchCartItems() {
  try {
    const response = await fetch("/cart.js", { cache: "no-store" });
    if (!response.ok) {
      throw new Error("Something wrongs");
    }
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      console.log("Empty cart, refetching...");
      return await fetchCartItems();
    }
    return cart;
  } catch (error) {
    console.error("Fetch error:", error);
  }
}

/** Mobile menu functions */
const menuContainer = document.querySelector(".first-level"); // first-level container
const secondLevelContainer = document.querySelector(".second-level"); // second-level container
const backBtn = secondLevelContainer.querySelector("[data-back-btn]");
let history = [];

function showMenu(selector) {
  // Hide all submenus in second level
  secondLevelContainer
    .querySelectorAll("ul")
    .forEach((ul) => ul.classList.add("hidden"));

  // Show the requested menu if selector is provided
  if (selector) {
    const menu = secondLevelContainer.querySelector(selector);
    if (menu) menu.classList.remove("hidden");
  }

  // Toggle back button visibility
  backBtn.classList.toggle("hidden", history.length === 0);
}

const menuMobileBrands = document.querySelector(".menu-mobile-brands");
// First-level click → show second-level
menuContainer.querySelectorAll("[data-menu]").forEach((item) => {
  item.addEventListener("click", function (e) {
    const menuUrl = this.querySelector('a').getAttribute("href");
    if (menuUrl == 'javascript:;') {
      e.preventDefault();
      const menuKey = this.getAttribute("data-menu");
      const target = `[data-menu-mobile-parent='${menuKey}']`;
      const mobileBrands = document.querySelectorAll("[data-mobile-brands]");
      const currentMobileBrand = document.querySelector(
        `[data-mobile-brands='${menuKey}']`
      );
      menuMobileBrands.style.display = "none";

      mobileBrands.forEach((parent) => {
        parent.classList.remove("flex");
        parent.classList.add("hidden");
      });

      if (currentMobileBrand) {
        currentMobileBrand.classList.remove("hidden");
        currentMobileBrand.classList.add("flex");
        menuMobileBrands.style.display = "block";
      }

      history.push(menuContainer); // store first-level in history
      menuContainer.classList.add("hidden"); // hide first-level
      secondLevelContainer.classList.remove("hidden"); // show second-level
      showMenu(target);
    }
  });
});

// Second-level click → show child-level
secondLevelContainer
  .querySelectorAll("[data-menu-mobile-parent]")
  .forEach((item) => {
    item.addEventListener("click", function (e) {
      const menuKey = this.getAttribute("data-menu-mobile-parent");
      const target = `[data-menu-mobile-child='${menuKey}']`;
      const child = secondLevelContainer.querySelector(target);

      if (child) {
        e.preventDefault();
        history.push(this.closest("ul")); // store current parent menu
        showMenu(target);
      }
    });
  });

// Back button
backBtn.addEventListener("click", function (e) {
  e.preventDefault();
  const prev = history.pop();

  if (prev === menuContainer) {
    // Back to first-level
    secondLevelContainer.classList.add("hidden");
    menuContainer.classList.remove("hidden");
  } else if (prev) {
    // Back to previous submenu
    showMenu(
      `[data-menu-mobile-parent='${prev.getAttribute(
        "data-menu-mobile-parent"
      )}']`
    );
  } else {
    // fallback
    secondLevelContainer.classList.add("hidden");
    menuContainer.classList.remove("hidden");
  }
});

/** Progressbar for articles */
const progressBar = document.getElementById("progressbar");
const progressBarMobile = document.getElementById("progressbar-mobile");

window.addEventListener("scroll", () => {
  if (!progressBar) return;

  // Find the column element with the specified classes
  const column = document.querySelector(
    ".main-article-wrapper"
  );

  if (!column) return;

  const scrollTop = window.scrollY;
  const columnRect = column.getBoundingClientRect();
  const columnTop = columnRect.top + scrollTop;
  const columnBottom = columnTop + columnRect.height;
  const viewportHeight = window.innerHeight;

  // Calculate when the column starts and ends being visible
  const columnStart = columnTop;
  const columnEnd = columnBottom - viewportHeight;

  // Calculate progress based on column visibility
  let scrollPercent = 0;

  if (scrollTop >= columnStart && scrollTop <= columnEnd) {
    // Column is partially visible, calculate progress
    scrollPercent =
      ((scrollTop - columnStart) / (columnEnd - columnStart)) * 100;
  } else if (scrollTop > columnEnd) {
    // Column is completely scrolled past
    scrollPercent = 100;
  }

  // Clamp between 0 and 100
  scrollPercent = Math.max(0, Math.min(100, scrollPercent));

  progressBar.style.width = scrollPercent + "%";
  if (progressBarMobile) progressBarMobile.style.width = scrollPercent + "%";
});

/** TOC of article */
const tocList = document.getElementById("toc");
const headings = document.querySelectorAll(".page-content h2, .page-content h3:not(.special)");

if (tocList) {
  headings.forEach((heading, index) => {
    if (!heading.classList.contains('toc-header')) {
      if (!heading.id) {
        heading.id = `toc-heading-${index + 1}`;
      }
      const li = document.createElement("li");
      li.textContent = heading.textContent; // plain text

      if (heading.tagName.toLowerCase() === "h3") {
        li.classList.add("ml-5");
      }

      li.style.cursor = 'pointer';
      li.addEventListener("click", () => {
        const headerOffset = 160; // fixed header height
        const elementPosition = heading.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      });

      tocList.appendChild(li);
    }
  });
}

/** Fetch full smallcart */
const smallcartBtns = document.querySelectorAll(".btn-smallcart");
smallcartBtns.forEach((button) => {
  button.addEventListener("click", (event) => {
    event.preventDefault();
    const miniCart = button
      .closest(".cart-wrapper")
      .querySelector(".mini-cart");
    const smallcartChevron = button
      .closest(".cart-wrapper")
      .querySelector(".smallcart-chevron");
    if (miniCart.classList.contains("hidden")) {
      updateSmallcartPopup();
      if (smallcartChevron !== null) {
        if (smallcartChevron.classList.contains("rotate-90")) {
          smallcartChevron.classList.remove("rotate-90");
          smallcartChevron.classList.add("rotate-[270deg]");
        }
      }
    } else {
      hideCustomCartNotification();
      if (smallcartChevron !== null) {
        if (smallcartChevron.classList.contains("rotate-[270deg]")) {
          smallcartChevron.classList.remove("rotate-[270deg]");
          smallcartChevron.classList.add("rotate-90");
        }
      }
    }
  });
});

async function updateSmallcartPopup() {
  try {
    // Fetch the latest cart data
    const cart = await fetchSmallcart();

    if (cart) {
      showCustomCartNotification(cart, true);
    }
  } catch (error) {
    console.error("Error updating small cart:", error);
  }
}

async function fetchSmallcart() {
  try {
    const response = await fetch("/cart.js", { cache: "no-store" });
    if (!response.ok) {
      throw new Error("Something wrongs");
    }
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      console.log("Empty cart, refetching...");
      //return await fetchSmallcart();
    }
    return cart;
  } catch (error) {
    console.error("Fetch error:", error);
  }
}

/** Form validation */
function initFormValidation() {
  const formInputs = document.querySelectorAll(
    ".form-input input, .form-input textarea, .formful__input"
  );

  formInputs.forEach((input) => {
    // Add event listeners for real-time validation
    input.addEventListener("blur", validateField);
    //input.addEventListener("input", clearValidationState);
    input.addEventListener("input", validateField);
  });
}

function validateField(event) {
  const input = event.target;

  // Use .form-input or the wrapper for formful__input
  const formInput = input.closest(".form-input") 
                    || (input.classList.contains("formful__input") 
                        ? input.closest(".formful__field-wrapper") 
                        : null);

  if (!formInput) return;

  // Remove existing validation classes
  formInput.classList.remove("valid", "error");

  // Get validation rules
  const isRequired = input.hasAttribute("required");
  const value = input.value.trim();
  const inputType = input.type;

  let isValid = true;

  if (isRequired && !value) isValid = false;
  if (inputType === "email" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) isValid = false;
  if (inputType === "tel" && value && !/^[\+]?[0-9\s\-\(\)]{10,}$/.test(value)) isValid = false;
  if (inputType === "text" && isRequired && value && value.length < 2) isValid = false;

  if (value && isValid) {
    formInput.classList.add("valid");
  } else if (value && !isValid) {
    formInput.classList.add("error");
  }
}

function clearValidationState(event) {
  const input = event.target;

  const formInput = input.closest(".form-input") 
                    || (input.classList.contains("formful__input") 
                        ? input.closest(".formful__field-wrapper") 
                        : null);

  if (formInput) {
    formInput.classList.remove("valid", "error");
  }
}

// Initialize form validation when DOM is loaded
document.addEventListener("DOMContentLoaded", initFormValidation);
